/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import translate from 'services/i18n/translate';
import vodafoneLogoBrandmark from 'assets/images/vf-logo-brandmark.svg';
import { Vod } from '@wit/vtv-x-foundation-lib';
import { ImageLoader } from '..';

interface Props {
  event: Vod;
}

export default function OnDemandEventDetails({ event }: Props): JSX.Element {
  const releaseYear = event.metadata?.year;

  // TODO Should this element be implemented in the vod data structure?
  /*
    ! Currently, the provider's logo is hardcoded to the Vodafone logo brandmark.
    ! The vodasset data structure in the WEB1 app has the provider logo property with the Vodafone logo as default value and this is never changed.
  */
  const providerLogo = vodafoneLogoBrandmark;

  const releaseDateLabel = releaseYear
    ? translate
        .formatString(translate['programInfo.metadata.releaseDateValue'], {
          country: event.country || '',
          year: releaseYear,
        })
        .toString()
        .trim()
    : '-';

  return (
    <>
      <h6 id="ProgrammeInfoDetails_durationTitle" className="margin-top-22">
        {translate['programInfo.metadata.duration']}
      </h6>
      <span id="ProgrammeInfoDetails_duration">
        {event?.durationValue
          ? translate.formatString(translate['date.minutes'], { duration: event?.durationValue }).toString()
          : '-'}
      </span>

      <h6 id="ProgrammeInfoDetails_releaseDateTitle">{translate['programInfo.metadata.releaseDate']}</h6>
      <span id="ProgrammeInfoDetails_releaseDate">{releaseDateLabel} </span>

      <h6 id="ProgrammeInfoDetails_providerTitle">{translate['programInfo.metadata.provider']}</h6>
      <ImageLoader className="channel-logo" src={providerLogo} bemModifier={`eventDetailsLogo-${event.id}`} />
    </>
  );
}
